import { render, staticRenderFns } from "./CollapseRestricao.vue?vue&type=template&id=9dce0a02&scoped=true&lang=pug"
import script from "./CollapseRestricao.vue?vue&type=script&lang=js"
export * from "./CollapseRestricao.vue?vue&type=script&lang=js"
import style0 from "./CollapseRestricao.vue?vue&type=style&index=0&id=9dce0a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dce0a02",
  null
  
)

export default component.exports